<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="900px">
      <v-card>
        <v-card-title class="headline">Mark locations DELETED</v-card-title>
        <v-card-text>
          <v-progress-linear v-if="retirementLoading || retirementSaving" indeterminate color="red"></v-progress-linear>

          <v-alert :value="true" type="warning" outline class="mb-3">
            These locations will not be moved or physically removed. They will be marked DELETED and hidden from
            every location destination selector. Existing artwork, packing, and history references remain unchanged
            and will display the location as DELETED until a later movement changes current state.
          </v-alert>

          <div v-if="retirementLoading">Checking all references with the server…</div>

          <template v-else-if="retirementResults.length === 0">
            <v-card v-for="preview in retirementPreviews" :key="preview.location.id" class="mb-3 pa-3" flat>
              <div class="title red--text">
                {{ preview.location.name }} <span class="right">ID-{{ preview.location.id }}</span>
              </div>
              <template v-if="preview.status === 'preview'">
                <div class="mt-2">
                  Current/legacy artwork references: <b>{{ preview.references.artworks.records }}</b>
                  ({{ preview.references.artworks.field_references }} field references)
                </div>
                <div>
                  Current packing references: <b>{{ preview.references.packings.records }}</b>
                  ({{ preview.references.packings.field_references }} field references)
                </div>
                <div>
                  Movement-history references: <b>{{ preview.references.history.records }}</b>
                  ({{ preview.references.history.field_references }} destination/previous-location references)
                </div>
              </template>
              <div v-else class="red--text mt-2">{{ retirementError(preview) }}</div>
            </v-card>
          </template>

          <template v-else>
            <v-card v-for="result in retirementResults" :key="result.location.id" class="mb-3 pa-3" flat>
              <div class="title">{{ result.location.display_name }}</div>
              <div v-if="result.status === 'complete'" class="green--text">
                Confirmed by the server. The location is marked DELETED and all references were preserved.
              </div>
              <div v-else class="red--text">{{ retirementError(result) }}</div>
            </v-card>
          </template>
        </v-card-text>
        <v-card-actions class="pr-4 pb-4">
          <v-spacer></v-spacer>
          <template v-if="retirementResults.length > 0">
            <v-btn small dark @click="finishRetirement">done</v-btn>
          </template>
          <template v-else>
            <v-btn small :disabled="retirementLoading || retirementSaving" @click="cancelRetirement">cancel</v-btn>
            <v-btn small color="red" dark :loading="retirementSaving"
              :disabled="retirementLoading || retirementSaving || !allRetirementPreviewsReady"
              @click="retireLocations">mark DELETED</v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="mt-4 elevation-0">
      <v-card-title>
        <v-layout row my-3 mx-1>
          <span>
            <v-menu
              offset-y
              :close-on-content-click="true"
              class="text-xs-right mx-4 my-0 py-0 align-center"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  icon
                  color="black"
                  dark
                  v-on="on"
                  class="text-xs-right mx-0 mt-2 my-0 py-0"
                >
                  <v-icon small>supervisor_account</v-icon>
                </v-btn>
              </template>
              <v-list value="3">
                <v-list-tile
                  v-for="(item, index) in ownerships"
                  :key="index.id"
                  @click="toggleOwnership(item)"
                >
                  <!-- <v-list-tile-avatar v-if="item.id==sorting">
                    <v-icon>mdi-sort-ascending</v-icon>
                  </v-list-tile-avatar> -->
                  <!-- <v-list-tile-avatar v-else>
                    <v-icon></v-icon>
                  </v-list-tile-avatar> -->
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </span>
          <span class="text-xs-left mt-2 pt-1 title">
            {{ selectedOwnership.name }}
          </span>
          <v-spacer></v-spacer>
        </v-layout>

        <v-btn
          class="ml-2 mb-0 mt-3"
          small
          v-if="selected.length > 0 && c_user.delete_rights"
          color="red"
          @click="deleteLocations"
          dark
          >Mark Locations DELETED</v-btn
        >
        <v-btn
          class="ml-1 mr-5 mb-0 mt-3"
          small
          v-if="selected.length > 0 && c_user.delete_rights"
          color="black"
          @click="resetSelected"
          dark
          >Clear Selection</v-btn
        >

        <v-spacer></v-spacer>

        <v-btn
          small dark
          color="black"
          class="mr-3 mt-3"
          @click="exportToExcel"
        >
          <v-icon small left>mdi-file-excel</v-icon>
          Export to Excel
        </v-btn>

        <!-- <v-btn-toggle v-model="afilter" class="mt-3 ml-2 mr-1">
          <v-btn small flat key="group1" class="px-2" input-value="2" value="2">
            <span> All </span>
          </v-btn>
          <v-btn small flat key="group2" class="px-2" input-value="1" value="1">
            <span> With artworks </span>
          </v-btn>
          <v-btn small flat key="group3" class="px-2" input-value="0" value="0">
            <span> No Artworks </span>
          </v-btn>
        </v-btn-toggle> -->

        <!-- <v-spacer></v-spacer> -->
        <v-text-field
          v-if="this.$store.state.showSearch"
          prepend-inner-icon="search"
          label="Search "
          clearable
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="table_locations_with_artworks"
        :pagination.sync="pagination2"
        :search="search"
        v-model="selected"
        item-key="id"
        must-sort
        rows-per-page-text="Locations per page"
        :loading="$store.state.loading_locations"
        no-results-text="No Locations match the criteria."
        class="elevation-0 mx-4"
      >
        <template slot="items" slot-scope="props">
          <!-- <td style="width:20px;">
            <v-checkbox
              primary
              hide-details
              v-model="props.selected"
              @change="save_currently_selected(props.selected,props.item)"
            ></v-checkbox>
          </td> -->
          <tr :class="{ black: props.expanded, 'white--text': props.expanded }">
            <td style="width:15px; padding:0px; margin:0px;">
              <v-checkbox
                color="black"
                primary
                hide-details
                v-model="props.selected"
              ></v-checkbox>
              <!-- @change="save_currently_selected(props.selected,props.item)" -->
            </td>
            <td>
              <router-link
                class="title"
                :class="{
                  black: props.expanded,
                  'white--text': props.expanded
                }"
                :to="{
                  name: 'EditLocation',
                  params: { id: props.item.id, location: props.item },
                  path: `/locations/edit/${props.item.id}`
                }"
              >
                {{ props.item.name }}
              </router-link>
              <!-- <br>{{ props.item.category }} -->
            </td>
            <td>{{ props.item.city }}</td>
            <td>{{ props.item.country_id }}</td>
            <!-- <td class="text-xs-center" style="width:30px;">{{ props.item.accession_number }}</td>-->
            <td class="text-xs-right" style="width:30px;">
              {{ getNoOfArtworksAtLocation(props.item.artworks) }}
              <!-- <td class="text-xs-right"> -->
              <v-btn icon small @click="props.expanded = !props.expanded">
                <!-- <a href="#" @click="props.expanded = !props.expanded" class=""> -->
                <!-- <span>show artworks </span> -->
                <v-icon
                  v-if="!props.expanded"
                  :class="{ 'white--text': props.expanded }"
                  >expand_more</v-icon
                >
                <v-icon
                  v-if="props.expanded"
                  :class="{ 'white--text': props.expanded }"
                  >expand_less</v-icon
                >
              </v-btn>
              <!-- </a>  -->
              <!-- <v-btn icon small @click="showDeleteDialog(props.item)">
                  <v-icon class="" color="red" small>delete</v-icon>
                </v-btn> -->
              <!-- </h3> -->
              <!-- <v-chip v-for="a in props.item.exhibition_artworks" v-bind:key="a.id" small >{{a.id}}</v-chip> -->
            </td>

            <!-- <td class="text-xs-right">
              <router-link style="padding-left:10px;" :to="{ name: 'EditLocation', params: {id: props.item.id, location: props.item}, path: `/locations/edit/${props.item.id}`}" >
              <v-btn icon><v-icon>edit</v-icon></v-btn>
              </router-link>
            </td> -->
          </tr>
        </template>

        <template v-slot:expand="props">
          <!-- <v-card-title>
            <v-text-field
              v-model="search[props.item.id]"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title> -->
          <!-- :headers="headers_related" -->
          <v-data-table
            must-sort
            class="elevation-0"
            :pagination.sync="pagination_related"
            hide-headers
            :items="location_artworks(props.item.id)"
            :search="search_related"
            v-model="selected_related"
            item-key="id"
            no-data-text="No Artworks at this location."
            no-results-text="No Artworks match the criteria."
          >
            <template slot="items" slot-scope="props_related">
              <tr>
                <td
                  style="text-align:center; vertical-align: text-top; width: 140px; padding: 7px 0 0 10px;"
                >
                  <img
                    @error="imageUrlAlt"
                    v-if="props_related.item.top_photo_id > 0"
                    v-bind:src="
                      `
                      ${$globals.oldserver}/data/artwork/${props_related.item.id}/${props_related.item.top_photo_id}_th_big.jpg`
                    "
                    style="width: 120px; margin:10px;"
                    :class="{
                      redBorder:
                        props_related.item.top_photo.width < 500 ||
                        props_related.item.top_photo.height < 500
                    }"
                  />
                  <img
                    @error="imageUrlAlt"
                    v-else
                    :src="imageUrlAlt"
                    style="width: 120px; margin:10px;"
                  />
                </td>
                <td>
                  <!-- <v-btn style="width:20px; height:20px" round color="red" icon small dense @click="remove_from_selection(props.item.id,props_related.item.id)" hint="Remove From the Selection"> 
                    <v-icon small dense color=white>remove</v-icon>
                  </v-btn> -->
                  <router-link
                    :to="{
                      name: 'EditArtwork',
                      params: {
                        id: props_related.item.id,
                        artwork: props_related.item
                      },
                      path: `/artworks/edit/${props_related.item.id}`
                    }"
                    class="subheading"
                  >
                    {{
                      props_related.item.artist
                        ? props_related.item.artist.name
                        : props_related.item.name
                    }},
                    <strong>{{ props_related.item.title }}</strong>
                    <!-- , {{props_related.item.accession_number}} -->
                  </router-link>

                  <!-- <v-icon class="ml-2" small>edit</v-icon> -->
                </td>
                <td align="right" class="title">
                  {{ props_related.item.accession_number }}
                </td>
                <!-- <td align="right" class="pr-0 mr-0"> 
                  <v-btn round icon small flat @click="remove_from_selection(props.item.id,props_related.item.id)" hint="Remove From the Selection"> 
                    <v-icon small>remove</v-icon> 
                  </v-btn>
                </td> -->
              </tr>
            </template>
          </v-data-table>

          <v-flex
            style="background-color:#292929; color: #eee;"
            class="px-3 py-1 my-0 elevation-0 xs12"
          >
            <h3 class="font-weight-bold subtitle xs12 flex">&nbsp; &nbsp;</h3>
          </v-flex>
        </template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no locations.
        </v-alert>
        <template slot="no-data">
          <index-load-state
            :loading="$store.state.loading_locations"
            :error="$store.state.load_errors.locations"
            empty-text="No Locations Found."
          ></index-load-state>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { serverBus } from '../../main'
import axios from '@/utils/apiClient'
import XLSX from 'xlsx'
import IndexLoadState from '@/components/general/IndexLoadState.vue'
export default {
  components: { IndexLoadState },
  data() {
    return {
      selectedOwnership: {},
      ownerships: [],
      filtered: [],
      dialog: false,
      artworks: [],
      artworks2: [],
      location: {},
      selectedLocation: {},
      afilter: '2',
      locations: [],
      search_related: '',
      selected_related: [],
      retirementLoading: false,
      retirementSaving: false,
      retirementPreviews: [],
      retirementResults: [],
      pagination2: {
        rowsPerPage: 10,
        sortBy: 'name'
      },
      pagination_related: {
        descending: true,
        // rowsPerPage: 10,
        sortBy: 'title'
      },
      show_tag_filter: false,
      show_classifications: false,
      filter: {
        selected_classifications: [],
        selected_classification_negations: []
      },
      ta: [],
      selected_tags: [],
      // selected_categories: [],
      // location_categories: [
      //   {id:1, name: 'loan_borrower', color: 'red', position: 2},
      //   {id:3, name: 'loan_contact_person', color: 'blue', position: 1},
      //   {id:7, name: 'loan_insurance_company', color: 'purple', position: 7},
      //   {id:2, name: 'artwork_acquisition_source', color: 'green', position: 3},
      //   {id:4, name: 'registrar', color: 'yellow', position: 4},
      //   {id:5, name: 'staff', color: 'pink', position: 5},
      //   {id:6, name: 'device_acquisition_company', color: 'grey', position: 6},
      //   {id:8, name: 'staff_external', color: 'grey', position: 8},
      //   {id:9, name: 'trustee', color: 'grey', position: 9}
      // ],
      selected: [],
      search: '',
      headers: [
        { text: '', sortable: false, value: '' },
        { text: 'Location', value: 'name', align: 'left' },
        { text: 'City', value: 'city', align: 'left' },
        { text: 'Country', value: 'country_id', align: 'left' },
        {
          text: 'Number of artworks at location',
          value: 'artworks.length',
          align: 'right'
        }
        // { text: '', value:'',align: 'right' }
      ]
    }
  },
  props: ['items'],
  created: function() {
    ;(this.selectedOwnership.id = 2),
      (this.locations = this.$store.state.locations)
    this.ownerships = Object.assign([], this.$store.getters.my_ownerships)
    this.ownerships.unshift({ id: 'all', name: 'All' })
    this.toggleOwnership(
      this.$store.state.filters['locations']
        ? this.$store.state.filters['locations']
        : this.ownerships[0]
    )
    // this.toggleOwnership(this.ownerships[0]);
  },
  methods: {
    exportToExcel() {
      // Prepare data for export
      const data = this.table_locations_with_artworks.map(location => ({
        'Location': location.name,
        'City': location.city,
        'Country': location.country_id,
        'Number of artworks at location': location.artworks.length
      }))

      // Create worksheet
      const ws = XLSX.utils.json_to_sheet(data)
      
      // Create workbook
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Locations')
      
      // Generate Excel file
      XLSX.writeFile(wb, `locations_${new Date().toISOString().split('T')[0]}.xlsx`)
    },
    getNoOfArtworksAtLocation(as) {
      if (this.selectedOwnership.id != 'all') {
        return as.filter(a => this.selectedOwnership.id == a.ownership).length
      } else {
        return as.length
      }
    },
    toggleOwnership(o) {
      // var array = [];
      // for (var i in ownerships) {
      //   // array.push(i);
      //   array.push(ownerships[i]);
      // }
      // console.log(array);
      // console.log(this.ownerships);
      // console.log(array.indexOf(this.s_ownership));
      // console.log(this.s_ownership);
      // console.log(this.ownerships.indexOf(this.s_ownership));
      this.$store.dispatch('setFilter', { section: 'locations', ownership: o })
      this.selectedOwnership = o
    },
    imageUrlAlt(event) {
      event.target.src = '/static/no_image.jpg'
    },
    resetSelected() {
      this.selected = []
      this.artworks = []
      this.artworks2 = []
    },
    async deleteLocation(c) {
      this.selected = []
      this.selected.push(c)
      await this.openRetirementDialog()
    },
    async deleteLocations() {
      await this.openRetirementDialog()
    },
    async openRetirementDialog() {
      this.dialog = true
      this.retirementLoading = true
      this.retirementPreviews = []
      this.retirementResults = []

      for (const location of this.selected) {
        try {
          const response = await axios.get(
            `${this.$globals.apiserver}/artwork_locations/${location.id}/retirement.json`
          )
          this.retirementPreviews.push(response.data)
        } catch (error) {
          this.retirementPreviews.push(this.retirementFailure(error, location))
        }
      }

      this.retirementLoading = false
    },
    async retireLocations() {
      this.retirementSaving = true
      const results = []

      for (const preview of this.retirementPreviews) {
        try {
          const response = await axios.post(
            `${this.$globals.apiserver}/artwork_locations/${preview.location.id}/retirement.json`
          )
          results.push(response.data)
          if (response.data.status === 'complete') {
            const stored = this.$store.state.locations.find(
              location => location.id === response.data.location.id
            )
            if (stored) this.$set(stored, 'disabled', 1)
          }
        } catch (error) {
          results.push(this.retirementFailure(error, preview.location))
        }
      }

      this.retirementResults = results
      this.retirementSaving = false
      this.$store.dispatch('loadLocations')

      if (results.every(result => result.status === 'complete')) {
        serverBus.$emit('showSnackbar', 'Location retirement confirmed by the server.', 'green')
      } else {
        serverBus.$emit('showSnackbar', 'Some locations were not confirmed as DELETED.', 'red')
      }
    },
    retirementFailure(error, location) {
      const responseData = error.response && error.response.data
        ? error.response.data
        : {
            status: 'unknown',
            reason: 'server_result_unknown',
            errors: { base: ['The server did not return a confirmed result.'] }
          }
      return {
        ...responseData,
        location: responseData.location || {
          id: location.id,
          name: location.name,
          display_name: location.name,
          disabled: location.disabled == 1
        }
      }
    },
    retirementError(result) {
      const errors = result.errors || {}
      const messages = Object.keys(errors).reduce((all, field) => {
        const values = Array.isArray(errors[field]) ? errors[field] : [errors[field]]
        return all.concat(values.map(value => `${field}: ${value}`))
      }, [])
      return messages.join('; ') || result.reason || 'The operation was not confirmed.'
    },
    cancelRetirement() {
      if (this.retirementLoading || this.retirementSaving) return
      this.dialog = false
      this.retirementPreviews = []
    },
    finishRetirement() {
      this.dialog = false
      this.retirementPreviews = []
      this.retirementResults = []
      this.selected = []
    },
    location_artworks(id) {
      var a = this.$store.state.artworks.filter(function(artwork) {
        if (this.selectedOwnership.id === 'all') {
          return artwork.artwork_location_id == id;
        } else {
          return artwork.artwork_location_id == id && this.selectedOwnership.id == artwork.ownership;
        }
      }.bind(this));
      return a;
    },
    switchSwitch() {
      this.show_tag_filter = !this.show_tag_filter
      this.$emit('switchOwnershipTop', this.show_tag_filter)
    },
    clearFilters() {
      this.selected_tags = []
      this.selected_tag_categories = []
    },
    clear_selection() {
      this.$store.dispatch('clearCurrentSelection')
      this.selected = []
    },
    select_all() {
      this.selected = this.table_locations
      var temp_selection = Object.assign([], this.$store.state.currentSelection)
      this.table_locations.forEach(a => {
        if (!temp_selection.includes(a)) {
          temp_selection.push(a)
        }
      })
      this.$store.dispatch('saveCurrentSelection', temp_selection)
    },
    save_selection() {
      this.$store.dispatch('clearCurrentSelection')
    },
    save_currently_selected(a, b) {
      setTimeout(
        function() {
          var temp_selection = Object.assign(
            [],
            this.$store.state.currentSelection
          )
          //// console.log(temp_selection)
          if (!a) {
            // console.log('a true')
            if (!temp_selection.includes(b)) {
              // console.log('doesnt include')
              temp_selection.push(b)
            }
          } else {
            // console.log('false')
            var index = temp_selection.indexOf(b)
            // console.log('index = ' + index)
            temp_selection.splice(index, 1)
          }
          this.$store.dispatch('saveCurrentSelection', temp_selection)
        }.bind(this),
        1000
      )
    },
    save_currently_selected_all(a) {
      // console.log('///////////')
      // console.log('a = ' + a)
      var temp_selection = Object.assign([], this.$store.state.currentSelection)
      // console.log(temp_selection)
      if (!a) {
        // console.log('a true')
        if (!temp_selection.includes(b)) {
          // console.log('doesnt include')
          temp_selection.push(b)
        }
      } else {
        // console.log('false')
        var index = temp_selection.indexOf(b)
        // console.log('index = ' + index)
        temp_selection.splice(index, 1)
      }
      // this.$store.state.currentSelection
      // console.log(temp_selection)
      // this.selected.forEach(s => {
      //   if (!temp_selection.includes(s)) {
      //     temp_selection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', temp_selection)
    },
    save_currently_selected_tags() {
      this.$store.dispatch('saveCurrentSelectionTags', this.selected_tags)
      this.ta = this.tagged_locations
    }
  },
  computed: {
    allRetirementPreviewsReady() {
      return this.retirementPreviews.length === this.selected.length &&
        this.retirementPreviews.length > 0 &&
        this.retirementPreviews.every(preview => preview.status === 'preview')
    },
    // currrent_path() {
    //   return this.$route.params.ownership;
    // },
    // saved_lists() {
    //   return [
    //     { id: 1, title: "list1" },
    //     { id: 2, title: "list2" }
    //   ];
    // },
    // selected_locations() {
    //   return this.$store.state.currentSelection;
    // },
    table_locations_with_artworks() {
      var out = this.$store.state.locations.filter(l => l.disabled != 1)
      out.forEach(
        item => (item.artworks = [...this.location_artworks(item.id)])
      )
      if (this.selectedOwnership.id != 'all') {
        out = out.filter(a =>
          a.artworks.some(ea => ea.ownership == this.selectedOwnership.id)
        )
      }

      // .map(l => {
      //   l.artworks = this.location_artworks(l.id);
      //   return l;
      // });

      // if (this.afilter == '1') {
      //   console.log('1')
      //   return out.filter(l => this.location_artworks(l.id).length > 0)
      // } else if (this.afilter == '0') {
      //   console.log('0')
      //   return out.filter(l => this.location_artworks(l.id).length == 0)
      // } else {
      //   console.log('000')
        return out
      // }
    },
    sorted_locations() {
      const ls = Object.assign([], this.$store.getters.enabled_locations)
      return ls.sort(function(a, b) {
        return a.name.toUpperCase().localeCompare(b.name.toUpperCase())
      })
    }
    // table_contacts() {
    //   return this.$store.state.contacts.filter(
    //     c =>
    //       c.category == "artwork_acquisition_source" ||
    //       c.category == "registrar"
    //   );
    //   // }
    // },
    // table_locations() {
    //   if (this.afilter == 1) {
    //     // var cst = this.selected_categories
    //     var a = this.locations.filter(function(location) {
    //       // console.log(location)
    //       return cst.indexOf(location.category) > -1;
    //     });
    //     // console.log(a)
    //     return this.locations.filter(function(location) {
    //       // console.log(cst)
    //       // console.log(cst.indexOf(location.category))
    //       return cst.indexOf(location.category) > -1;
    //     });
    //   } else {
    //     return this.items;
    //   }
    // },
    // tagged_locations() {
    //   var cst = this.$store.state.currentSelectionTags;
    //   return this.table_locations.filter(function(location) {
    //     return location.tags.some(a_tag => cst.indexOf(a_tag.id) > -1);
    //   });
    // },
    // select_categories() {
    //   var stc = this.selected_tag_categories;
    //   var tc = this.tag_categories;
    //   var tags = Object.assign([], this.$store.state.tags);
    //   var out = [];
    //   // console.log(tags)
    //   tags.forEach(tag => {
    //     var a = tc.filter(function(tagc) {
    //       return tagc.id == tag.tag_category_id;
    //     });
    //     // console.log(a[0].color)
    //     tag.color = a[0].color;
    //     out.push(tag);
    //   });
    //   // console.log(out)
    //   return out.filter(function(tag) {
    //     return stc.some(st => tag.tag_category_id == st);
    //   });
    // }
  }
}
</script>

<style scoped>
td {
  height: 80px !important;
}
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/locations/LocationsTable.vue